RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UrlDiffAlert = views.Alert.extend({
        template: '#alertsUrlDiffAlertTemplate',
        getDiffPrevious: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            return eventDisplay.getTextDiff(data.event_type_id, data, $.noop);
        },
        getDiffCurrent: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            return eventDisplay.getTextDiff(data.event_type_id, data, null, $.noop);
        },
        getDiffSubject: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const eventDisplay = RivalIQ.utils.eventDisplay;

            return eventDisplay.getTextDiffSubject(data.event_type_id);
        },
        getAlertIconClassName: function () {
            const me = this;
            const eventTypeId = me.model.get('event_type_id');
            const eventDisplay = RivalIQ.utils.eventDisplay;

            const sourceDetails = eventDisplay.getSourceDetails(eventTypeId);
            return sourceDetails.fontIcon;
        },
        augmentTemplateData: function (data) {
            const me = this;

            views.Alert.prototype.augmentTemplateData.apply(me, arguments);

            data.diffSubject = me.getDiffSubject(data);
            const eventData = data.data;

            if (_.has(eventData, ['urls'])) {
                // This is a new-style url diff event.
                data.diffCurrent = null;
                data.diffPrevious = null;
                data.urls = eventData.urls;
            } else {
                // This is an old-style text diff event.
                data.diffCurrent = me.getDiffCurrent(data);
                data.diffPrevious = me.getDiffPrevious(data);
                data.urls = {};
            }
        }
    });

});
